import { render, staticRenderFns } from "./afterApplyDetails.vue?vue&type=template&id=63f3ca88&scoped=true&"
import script from "./afterApplyDetails.vue?vue&type=script&lang=js&"
export * from "./afterApplyDetails.vue?vue&type=script&lang=js&"
import style0 from "./afterApplyDetails.vue?vue&type=style&index=0&id=63f3ca88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f3ca88",
  null
  
)

component.options.__file = "afterApplyDetails.vue"
export default component.exports